import * as React from 'react'

const LockBlack = () => {
  return (
    <svg
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5402 6.5051H10.042V4.42347C10.042 1.95153 8.43218 0 6.20915 0C3.94779 0 2.37634 1.9949 2.37634 4.42347V6.5051H1.9164C0.843218 6.5051 0 7.45918 0 8.67347V15.1786C0 16.3929 0.843218 17.3469 1.9164 17.3469H10.5402C11.6134 17.3469 12.4566 16.3929 12.4566 15.1786V8.67347C12.4566 7.45918 11.5751 6.5051 10.5402 6.5051ZM3.33454 4.42347C3.33454 2.55867 4.44606 1.08418 6.20915 1.08418C7.93391 1.08418 9.08375 2.55867 9.08375 4.42347V6.5051H3.33454V4.42347ZM11.4984 15.1786C11.4984 15.7857 11.0768 16.2628 10.5402 16.2628H1.9164C1.37981 16.2628 0.958202 15.7857 0.958202 15.1786V8.67347C0.958202 8.06633 1.37981 7.58929 1.9164 7.58929H10.5402C11.0768 7.58929 11.4984 8.06633 11.4984 8.67347V15.1786Z"
        fill="black"
      />
      <path
        d="M6.2082 9.75757C5.67161 9.75757 5.25 10.2346 5.25 10.8418C5.25 11.2321 5.44164 11.579 5.74827 11.7958V13.5739C5.74827 13.8775 5.97823 14.1377 6.2082 14.1377C6.43817 14.1377 6.70647 13.8775 6.70647 13.5739V11.7958C6.97476 11.6224 7.20473 11.2754 7.20473 10.8418C7.1664 10.2346 6.74479 9.75757 6.2082 9.75757Z"
        fill="black"
      />
    </svg>
  )
}

export default LockBlack
